import { useGet, useQueryWithErrorHandling } from '@app/sdk';
import { Merchant } from '@app/models';
import { merchantBaseUrl } from '../BaseUrls';

const pillarCode = "tms";

export function useGetMerchant({ id }: { id: string }) {
  const get = useGet(true, pillarCode);
  return useQueryWithErrorHandling({
    queryKey: ['get-merchant', id],
    queryFn: async () => await get<Merchant>(`${merchantBaseUrl}/merchants/${id}`),
    enabled: !!id,
  });
}
